import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigateAndHideMenu } from "@faire/retailer-visitor-shared/components/Header/mobile/Navigation/useNavigateAndHideMenu";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { Suspense } from "react";
import { useHeaderSignUpCopy } from "@faire/retailer/components/Header/__internal__/useHeaderSignUpCopy";
import { HeaderAccountDropdown } from "@faire/retailer/components/Header/desktop/HeaderAccountDropdown";
import { LazyHeaderLanguageSelector } from "@faire/retailer/components/Header/desktop/HeaderLanguageSelector/LazyHeaderLanguageSelector";
import { HeaderNotificationsDropdown } from "@faire/retailer/components/Header/HeaderNotifications/HeaderNotificationsDropdown";
import { HeaderButton, HeaderLine, HeaderLinkButton } from "@faire/retailer/components/Header/styled";
export var LoginSection = /*#__PURE__*/ React.memo(function(param) {
    var signUpCTAText = param.signUpCTAText;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var showLanguageSelector = useRetailerStore([
        "showLanguageSelector"
    ]).showLanguageSelector;
    var _useUserStore = useUserStore([
        "browserLevelLanguage",
        "browserLevelLocaleKey"
    ]), browserLevelLanguage = _useUserStore.browserLevelLanguage, browserLevelLocaleKey = _useUserStore.browserLevelLocaleKey;
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = (_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    return isLoggedInRetailer ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showLanguageSelector ? /*#__PURE__*/ _jsx(LanguageSelectorSection, {
                eventKey: "logged-in-top",
                browserLanguage: browserLevelLanguage,
                browserLocale: browserLevelLocaleKey,
                availableLocales: availableLanguageSelectorLocales,
                assignLocalizedUrl: true
            }) : null,
            /*#__PURE__*/ _jsx(HeaderNotificationsDropdown, {}),
            /*#__PURE__*/ _jsx(HeaderAccountDropdown, {})
        ]
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LoginLink, {}),
            /*#__PURE__*/ _jsx(SignUpLink, {
                signUpCTAText: signUpCTAText
            })
        ]
    });
});
var LoginLink = function() {
    var navigateToSignIn = useNavigateAndHideMenu().navigateToSignIn;
    return /*#__PURE__*/ _jsx(HeaderLinkButton, {
        onClick: function() {
            return navigateToSignIn();
        },
        "data-test-id": "login",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "pRbY2n",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sign in"
                }
            ]
        })
    });
};
var LanguageSelectorSection = function(props) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyHeaderLanguageSelector, _object_spread({}, props))
            }),
            /*#__PURE__*/ _jsx(HeaderLine, {})
        ]
    });
};
var SignUpLink = function(param) {
    var signUpCTAText = param.signUpCTAText;
    var isSSR = useIsSSR();
    var navigateToSignUp = useNavigateAndHideMenu().navigateToSignUp;
    var signUpCopy = useHeaderSignUpCopy();
    return /*#__PURE__*/ _jsx(HeaderButton, {
        onClick: function() {
            return navigateToSignUp(undefined, {
                sourceId: "desktop_catnav_signup_cta"
            });
        },
        // We set a link for graceful degradation in SSR.
        linkTo: isSSR ? getCurrentPath().replace({
            signUp: "1"
        }).toString() : undefined,
        "data-test-id": "signUpButton",
        children: signUpCTAText !== null && signUpCTAText !== void 0 ? signUpCTAText : signUpCopy
    });
};
